export default {"src":"/_next/static/media/generating-icon-red.bb6f524c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};